import { Component } from 'react';
import UIProgress from 'UIComponents/progress/UIProgress';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NINETY_NINETH_PERCENTILE, NINTIETH_PERCENTILE, SEVENTY_FIFTH_PERCENTILE, FIFTIETH_PERCENTILE, TWENTY_FIFTH_PERCENTILE, TENTH_PERCENTILE } from '../constants/networkConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class NetworkStatistics extends Component {
  render() {
    const omnibusDuration = performance.getEntriesByName('conversations-early-omnibus', 'measure').length > 0 ? Math.round(performance.getEntriesByName('conversations-early-omnibus', 'measure')[0].duration) : null;
    let percentile;
    let speed;

    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (omnibusDuration < NINETY_NINETH_PERCENTILE) {
      percentile = 99;
      speed = 'faster';
    }
    if (
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration > NINETY_NINETH_PERCENTILE &&
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration < NINTIETH_PERCENTILE) {
      percentile = 90;
      speed = 'faster';
    }
    if (
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration > NINTIETH_PERCENTILE &&
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration < SEVENTY_FIFTH_PERCENTILE) {
      percentile = 75;
      speed = 'faster';
    }
    if (
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration > SEVENTY_FIFTH_PERCENTILE &&
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration < FIFTIETH_PERCENTILE) {
      percentile = 50;
      speed = 'faster';
    }
    if (
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration > FIFTIETH_PERCENTILE &&
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration < TWENTY_FIFTH_PERCENTILE) {
      percentile = 50;
      speed = 'faster';
    }
    if (
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration > TWENTY_FIFTH_PERCENTILE &&
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    omnibusDuration < TENTH_PERCENTILE) {
      percentile = 25;
      speed = 'slower';
    }
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    if (omnibusDuration > TENTH_PERCENTILE) {
      percentile = 10;
      speed = 'slower';
    }
    if (!percentile || !speed) return /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'conversations-inbox-ui.performance-reporting.network-statistics.error'
    });
    return /*#__PURE__*/_jsx("div", {
      children: omnibusDuration < FIFTIETH_PERCENTILE ? /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'conversations-inbox-ui.performance-reporting.network-statistics.networkDiagnosticMessageFaster',
          options: {
            omnibusDuration,
            percentile
          }
        }), /*#__PURE__*/_jsx(UIProgress, {
          use: "success",
          value: percentile
        })]
      }) : /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'conversations-inbox-ui.performance-reporting.network-statistics.networkDiagnosticMessageSlower',
          options: {
            omnibusDuration,
            percentile
          }
        }), /*#__PURE__*/_jsx(UIProgress, {
          use: "warning",
          value: percentile
        })]
      })
    });
  }
}
NetworkStatistics.displayName = 'NetworkStatistics';